module.exports = __webpack_public_path__ + "img/whathot_s04.8eee295f.png";